import { Store } from '../Store';
import { addLinkParamsInStore, addAllRefPCPClinAndActonPopUpOpenInStore, addAllRefPCPAndACtionPlanDetailsInStore } from './reducer';

export const addLinkParamsToStore = (data) => Store.dispatch(addLinkParamsInStore(data));

export const addAllRefPCPClinAndActonPopUpOpenToStore = (val) => Store.dispatch(addAllRefPCPClinAndActonPopUpOpenInStore(val));

export const addAllRefPCPAndACtionPlanDetailsToStore = (val) => Store.dispatch(addAllRefPCPAndACtionPlanDetailsInStore(val));
